import { useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { actionConsts, actionConts2, reducer } from "../newComponents/StateManager";
import { HbrCancel } from "../newComponents/Mycustomsvgicons";
import { ConstVariables } from "./ConstantVariables";
import { AuthContext } from "../AuthContext";
import { MessageGenreListDefault, Preachers } from "../Utils/ArraysofData";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { getMessageGenres, initDB, storeMessageGenreToLocalDB } from "../ConfigureIndexDB";
import AxiosApi from "./AxiosApi";

const EditMessage = ({title, messagePreacher, description, videoUrl, thumbnail, audioUrl, genre, messageId, handleCancel}) => {
      const [messageTitle, setMessageTitle] = useState(title);
        const [preacher, setPreacher] = useState(messagePreacher);
        const [videoLink, setVideoLink] = useState(videoUrl);
        const [messageGenre, setMessageGenre] = useState(genre);
        const [uploading, setUploading] = useState(false);
        const [newGenre, setNewGenre] = useState("");
        const [messageGenresFromLocalDB, setMessageGenreListFromDB] = useState([]);
        const [state,dispatch]=useReducer(reducer,{videoUrl:"",capturedThumbnail:"", videoDescription: description, audioUrl:"",shortsDescCount: 0,uploadProgress: "",progressIndicator: false, showAlert: false, 
        alertMessage: "",showOptionalDialog: false});
        const {user_email}= useContext(AuthContext);
        const audioPlayerRef = useRef(null);
        const canvasRef = useRef(null);
        const maxwordLength = 400;

         useEffect(() => {
                async function fethcMessageGenres() {
                    await initDB();
                    const messageGenreFromDB = await getMessageGenres();
                    if (messageGenreFromDB.length > 0) {
                        setMessageGenreListFromDB([...messageGenreFromDB,...MessageGenreListDefault]);
                    }else{
                        setMessageGenreListFromDB(MessageGenreListDefault)
                    }
                }
                fethcMessageGenres();
                console.log(messageId)
            }, [messageId]);
        
        useEffect(()=>{
            if (state.videoDescription) {
                let words = state.videoDescription.split(' ');
                if(words.length >= maxwordLength){
                    words = words.slice(0,maxwordLength);
                    dispatch({type: actionConts2.VIDEO_DESCRIPTION, payload: words.join(' ')});
                }
                dispatch({type: actionConsts.SHORTS_DESC_COUNT, payload: words.length});
            }
        },[state.videoDescription]);
    
        
        const handleDisableDescriptionTextbox=(e)=>{
            if(state.shortsDescCount >= maxwordLength && e.key !== 'Backspace' && e.key !== 'Delete'){
                e.preventDefault();
            }
        };
        
    const updateMessage=async()=>{
        setUploading(true);
         const messageData = {
            messageId,
            title: messageTitle,
            preacher: preacher,
            description: state.videoDescription,
            videoUrl: videoLink,
            genre: messageGenre,
            user_email,
            api_key: process.env.REACT_APP_CONNECTERE_KEY,
        };
        try {
            const res = await AxiosApi.post("/updateMessage", JSON.stringify(messageData),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: res.data.success});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            setUploading(false);
        }catch (error) {
            if (!error?.response) {
                dispatch({type: actionConsts.ALERT_MESSAGE, payload: ConstVariables.NO_SERVER_RESPONSE});
                dispatch({type: actionConsts.SHOWALERT, payload: true});
            }else{
                dispatch({type: actionConsts.ALERT_MESSAGE, payload: error?.response.data.message});
                dispatch({type: actionConsts.SHOWALERT, payload: true});
            }
            setUploading(false);
        }
    };

    const storeNewGenre = async()=>{
        if (newGenre.trim() !== "") {
            try {
            const newGnereId = new Date().getTime();
            await initDB();
            await storeMessageGenreToLocalDB({id: newGnereId, genre: newGenre});
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: `${newGenre} is successfully to the genre list. Please select it from the dropdown.`});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            setMessageGenreListFromDB(prevGenres => [...prevGenres, {id: newGnereId, genre: newGenre}]);
            setNewGenre("");
            } catch (error) {
                console.error("Error storing new message genre:", error);
            }
        }else{
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: "Please enter a valid genre."});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
        }
    };
    const memoizedMessageGenreList = useMemo(() => messageGenresFromLocalDB,[messageGenresFromLocalDB]);

    const handleCloseAlert=(data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    };


    return ( 
        <div className="update-message">
            <div className="upload-messages-overlay flex-spacearound" style={{position:"relative",width:"100%", height:"100%", borderRadius:"10px"}}>
                <div className="flex-spacebetween" style={{position:"absolute", top:"0", left:"0", width:"100%", height:"50px"}}>
                    <h3 style={{color:"white", textAlign:"center", paddingTop:"10px"}}>Edit Message</h3>
                    <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>handleCancel()}/>
                </div>

                <div className="message-video flex-column1" style={{width:"45%", height:"100%", gap:"10px", marginTop:"150px"}}>
                    <label style={{color:"white", fontWeight:"bold"}}>Video Thumbnail</label>
                    {thumbnail && thumbnail !== "" ? 
                        <img className="hrmwmessage-thumbnail" src={thumbnail} alt="" style={{width:"150px", height:"150px", objectFit:"cover"}}/>
                        :
                        <div className="hrmwmessage-thumbnail-placeholder" style={{width:"150px",height:"150px",border:"2px solid white", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                            <h3 style={{color:"white"}}>Video Thumbnail</h3>
                        </div>
                    }
                    <canvas ref={canvasRef} style={{display:"none"}}/> <br/>
                      <div className="flex-spacearound" style={{width:"100%"}}>
                        <button className="buttonstyle" style={{backgroundColor:"green", color:"white"}} onClick={()=>updateMessage()}>
                            Update Message
                        </button> 
                    </div>
                </div>
                
                <div className="message-details flex-column1" style={{width:"50%", height:"100%", marginTop:"150px"}}>
                    <label>Message Title:</label>
                    <input type="text" required value={messageTitle} onChange={e => setMessageTitle(e.target.value)}/>
                    <br/>
                    
                    <label>Preacher</label>
                    <input type="text" list="preacher-list" required value={preacher} onChange={e => setPreacher(e.target.value)}/>
                    <datalist id="preacher-list">
                        {Preachers.map((data,index)=>(
                            <option key={index} value={data}></option>
                        ))}
                    </datalist>
                    <br/>
                    
                    <label>Description</label>
                    <textarea
                    required
                    placeholder="Message description" 
                    rows="6"
                    onKeyDown={handleDisableDescriptionTextbox}
                    value={state.videoDescription}
                    onChange={e => dispatch({type:actionConts2.VIDEO_DESCRIPTION, payload: e.target.value})}
                    style={{width:"100%", padding:"10px", outline:"none", border:"none", backgroundColor:"var(--warmer_dark_shade)", color:"var(--white)", fontWeight:"bold"}}
                    />
                    <br/>

                    <label>Audio Format:</label>
                    {audioUrl && audioUrl !== "" && 
                        <audio controls ref={audioPlayerRef} src={audioUrl} style={{width:"100%", height:"50px"}}/>
                    }
                    <br/><br/>

                    <label>{`Video (youtube link):`}</label>
                    <input type="url" required value={videoLink} onChange={e => setVideoLink(e.target.value)}/>
                    <br/>

                    <label>Message Genre</label>
                    <select required value={messageGenre} onChange={e => setMessageGenre(e.target.value)}>
                        {memoizedMessageGenreList && memoizedMessageGenreList.map((data, index)=>(
                            <option key={data?.id ? data.id : index } value={data.genre}>{data.genre}</option>
                        ))}
                    </select>
                    <br/>

                    <label>Add the appropriate message genre if not included in the list above</label>
                    <input type="text" value={newGenre} onChange={e => setNewGenre(e.target.value)} style={{width:"100%", padding:"10px", outline:"none", border:"none", backgroundColor:"var(--warmer_dark_shade)", color:"var(--white)", fontWeight:"bold"}}/>
                    <button className="buttonstyle" style={{backgroundColor:"white"}} onClick={()=>storeNewGenre()}>Add New Genre</button>
                    <br/>
                </div>

                {uploading && 
                    <div className="uploadshortsprogressinfo flex-column2">
                        <p style={{color: "white",fontWeight:"bold"}}>{state.uploadProgress}</p>
                        <div className="uploadshortspreloader">
                            <p style={{color: "white",fontWeight:"bold"}}>Updating ...</p>
                        </div>
                    </div>
                }
                {state.showAlert &&
                <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert} />
                }
            </div>
        </div>
     );
}
export default EditMessage;